import { styled } from "styled-components";
import { mobileBreakPointCSS } from "../../defaults/theme.js";
import { cssFontSize, cssSpacing, surfaceColorMap } from "../../util/styles.js";
import type { BackgroundColor } from "../../types/theme.js";

export const HeroLogoCard = styled.div<{ $bg?: BackgroundColor }>`
  display: grid;
  grid-template-columns: 1fr;
  overflow: hidden;
  border-radius: ${(props) => props.theme.borderRadius};
  background: ${(p) => surfaceColorMap[p.$bg || "surface2"]};
  color: ${(p) => (p.$bg === "surface3" ? "#fff" : "var(--swatch2)")};

  @media (min-width: ${mobileBreakPointCSS}) {
    grid-template-columns: 1fr 1fr;
    align-items: stretch;
    height: 360px;
  }
`;

export const HeroLogoMedia = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 0;

  img {
    display: block;
    width: 100%;
    height: auto;
    max-height: 100%;
    object-fit: contain;
  }
`;

export const HeroLogoContent = styled.div`
  padding: ${cssSpacing("s")};

  @media (min-width: ${mobileBreakPointCSS}) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: ${cssSpacing("m")};
  }
`;

export const HeroLogoTitle = styled.h1`
  margin: 0 0 ${cssSpacing("xs")};
  color: inherit;
  font-size: ${cssFontSize("large")};
  font-weight: 600;

  @media (min-width: ${mobileBreakPointCSS}) {
    font-size: ${cssFontSize("larger")};
  }
`;

export const HeroLogoText = styled.p`
  margin: 0;
  color: inherit;
  white-space: pre-wrap;
  font-size: ${cssFontSize("small")};
`;

export const HeroLogoLinks = styled.div`
  display: grid;
  grid-template-columns: repeat(2, max-content);
  gap: ${cssSpacing("xs")} ${cssSpacing("l")};
  margin-top: ${cssSpacing("s")};
`;

export const HeroLogoLink = styled.a`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  color: var(--hero-logo-link-color);
  font-size: ${cssFontSize("small")};
  font-weight: 400;
  line-height: 1.5;
  text-decoration-line: underline;
  text-decoration-skip-ink: none;
  text-underline-position: from-font;

  svg {
    flex-shrink: 0;
    color: var(--hero-logo-icon-color);

    path {
      fill: none;
      stroke: currentColor;
    }
  }
`;
